import { createSlice } from "@reduxjs/toolkit";
import { GradeLevelResponseDto } from "../../shared/dtos/gradeLevel/GradeLevelResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const gradeLevelSlice = createSlice({
  name: "gradeLevel",
  initialState: getInitialCrudState<GradeLevelResponseDto>(),
  reducers: {
    ...generateCrudReducers<GradeLevelResponseDto>(),
  },
});

export const gradeLevelActions = gradeLevelSlice.actions;
export default gradeLevelSlice.reducer;
